import PanelBoxLayout from 'components/layout/panelBox';
// import PaginationApp from "components/pagination";

// import * as T from "common/types";
import * as S from './styles';
import DangerButton from 'components/form/buttons/danger';
import Gap from 'components/gap';
// import RateStar from "components/rateStar";
import { useActions } from 'common/hooks/useActions';
import QuestionModal from 'components/modal/question';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import moment from 'moment';
import SecundButton from 'components/form/buttons/secundButton';

const urgencyMap = {
  '1': 'High',
  '2': 'Medium',
  '3': 'Low'
};

const priorityMap = {
  '1': 'Critical',
  '2': 'High',
  '3': 'Moderate',
  '4': 'Low',
  '5': 'Planning'
};

const statusMap = {
  '1': 'New',
  '2': 'In Progress',
  '3': 'On Hold',
  '4': 'Awaiting User Info',
  '5': 'Awaiting Evidence',
  '6': 'Resolved',
  '7': 'Closed',
  '8': 'Canceled'
};

interface IProps {
  data: any;
}

export default function TicketDetailInfo({ data }: IProps) {
  const { ticketChangeStatusRequestAction, ticketDetailRequestActionNew } = useActions();
  const [showCloseModal, setShowCloseModal] = useState<boolean>(false);

  const navigate = useNavigate();

  const handleShowCloseTicket = () => {
    setShowCloseModal(true);
  };

  const handleHideCloseTicket = () => {
    setShowCloseModal(false);
  };

  const handleCloseTicket = (note?: string) => {
    ticketChangeStatusRequestAction(data.id, 'CLOSED_BY_ADMIN', note, () => {
      ticketDetailRequestActionNew(data.id);
      handleHideCloseTicket();
    });
  };

  const handleChangeStatusTicket = (status: string) => {
    ticketChangeStatusRequestAction(data.id, status, undefined, () => {
      ticketDetailRequestActionNew(data.id);
    });
  };

  function getLabelFromMap<T extends Record<string, string>>(map: T, key: string | number): string {
    const keyStr = key.toString();
    return map[keyStr] || '-';
  }

  return (
    <S.Content>
      <PanelBoxLayout style={{ padding: '20px 30px' }}>
        <S.Head>Tickets General Details</S.Head>
        <Gap size="10px" />
        <S.Detail>
          <S.Item>
            <S.MainTitle>Requester</S.MainTitle>
            <S.Grid>
              <S.Icon src={data?.user?.profilePicture || '/images/default-avatar.jpg'} />
              <S.Text>{data?.user?.displayName}</S.Text>
            </S.Grid>
          </S.Item>

          <S.Item>
            <S.Title>Employee ID</S.Title>
            <S.Text>{data?.user?.id || '-'}</S.Text>
          </S.Item>
          <S.Item>
            <S.Title>Subject</S.Title>
            <S.Text>{data?.subject?.replace(/\r\n/g, '\n') || '-'}</S.Text>
          </S.Item>
          <S.Item>
            <S.Title>Description</S.Title>
            <S.Text>{data?.description?.replace(/\r\n/g, '\n') || '-'}</S.Text>
          </S.Item>
          <S.Item>
            <S.Title>Email</S.Title>
            <S.Text>{data?.user?.mail || '-'}</S.Text>
          </S.Item>
          {data?.createdAt && (
            <S.Item>
              <S.Title>Open Date</S.Title>
              <S.Text>{moment(data?.createdAt).format('YYYY.MM.DD - HH:MM') || '-'}</S.Text>
            </S.Item>
          )}
          <S.Item>
            <S.Title>Number</S.Title>
            <S.Text>{data?.number || '-'}</S.Text>
          </S.Item>
          {/* <Gap size="15px" />
          <S.MainTitle>Ticket Details</S.MainTitle> */}
          <S.Item>
            <S.Title>Status</S.Title>
            <S.Text>{getLabelFromMap(statusMap, data?.status || '-')}</S.Text>
          </S.Item>
          <S.Item>
            <S.Title>Priority</S.Title>
            <S.Text>{getLabelFromMap(priorityMap, data?.priority || '-')}</S.Text>
          </S.Item>
          <S.Item>
            <S.Title>Urgency</S.Title>
            <S.Text>{getLabelFromMap(urgencyMap, data?.urgency || '-')}</S.Text>
          </S.Item>

          {data?.closeNote && (
            <S.Item>
              <S.Title>Close Note</S.Title>
              <S.Text>{data?.closeNote}</S.Text>
            </S.Item>
          )}

          <S.Item style={{ borderBottom: 'none' }}>
            <S.Title>Ticket ID</S.Title>
            <S.Text>{data?.id}</S.Text>
          </S.Item>
        </S.Detail>
        <Gap size="20px" />
        <S.Div style={{ display: 'flex', alignItems: 'center', justifyContent: 'end', gap: 10 }}>
          {data?.status === 'NEW' ? (
            <>
              <DangerButton
                style={{
                  // background: "#DCF6F0",
                  // color: "var(--primary-green)",
                  fontSize: 14,
                  fontWeight: 400,
                  borderRadius: 8,
                  height: 36,
                  width: 208
                }}
                onClick={handleShowCloseTicket}
              >
                Close
              </DangerButton>
              <SecundButton
                style={{
                  // background: "#DCF6F0",
                  // color: "var(--primary-green)",
                  fontSize: 14,
                  fontWeight: 400,
                  borderRadius: 8,
                  height: 36,
                  width: 208
                }}
                onClick={() => handleChangeStatusTicket('IN_PROGRESS')}
              >
                Progress
              </SecundButton>
            </>
          ) : data?.status === 'IN_PROGRESS' ? (
            <DangerButton
              style={{
                // background: "#DCF6F0",
                // color: "var(--primary-green)",
                fontSize: 14,
                fontWeight: 400,
                borderRadius: 8,
                height: 36,
                width: 208
              }}
              onClick={handleShowCloseTicket}
            >
              Close
            </DangerButton>
          ) : (
            <DangerButton
              style={{
                // background: "#DCF6F0",
                // color: "var(--primary-green)",
                fontSize: 14,
                fontWeight: 400,
                borderRadius: 8,
                height: 36,
                width: 208,
                marginLeft: 'auto'
              }}
              disabled
            >
              {data?.status === 'CLOSED_BY_ADMIN'
                ? 'Closed by admin'
                : data?.status === 'CLOSED_BY_USER'
                  ? 'Closed by user'
                  : ''}
            </DangerButton>
          )}
        </S.Div>
      </PanelBoxLayout>

      <QuestionModal
        show={showCloseModal}
        handleClose={handleHideCloseTicket}
        model="delete"
        title="Close Ticket"
        text="Do you want to Close this Ticket?"
        handleSuccess={handleCloseTicket}
        successButtonText="Close"
        note
        notePlaceholder="Please enter close reason"
      />
    </S.Content>
  );
}
